export default __webpack_public_path__ + "static/media/Montserrat-BoldItalic.a32ae5d9.ttf";